import Vue from 'vue';

/** @obsolete */
export function computeAll(items, context) {
  items.forEach(item => compute(item, context));
}

export function compute(condition, context = {}, target = condition) {
  try {
    if (typeof condition !== 'string') {
      condition = condition?.condition;
    }

    if (!condition) {
      return;
    }

    let source;
    if (condition.includes('show:') || condition.includes('hide:')) {
      source = processConditionWithReplace(condition);
    } else {
      condition = interpolate(condition, context);
      source = evaluateConditionWithFunction(condition, context, target);
    }

    if (source) {
      updateTarget(source, target);
    }

    return target;
  } catch (error) {
    console.error(error);
    return target || {};
  }
}

function isComputable(condition) {
  return /\$\{[^}]+\}/.test(condition);
}

function interpolate(template, context) {
  return template.replace(/\$\{([^}]+)\}/g, (match, path) => {
    const keys = path.split('.').map(key => key.trim());
    let currentValue = context;
    for (const key of keys) {
      if (currentValue === null || typeof currentValue !== 'object') {
        return match;
      }
      currentValue = currentValue[key];
    }
    return currentValue !== undefined ? currentValue : match;
  });
}

function processConditionWithReplace(condition) {
  const conditionObj = {};
  const conditions = condition.split(/,(?![^{}]*\})/); // Split by commas outside of curly braces

  conditions.forEach(cond => {
    let [key, value] = cond.split(':').map(c => c.trim());
    if (value === 'show' || value === 'hide') {
      value += ': false'; // Convert dangling show/hide to false
    }
    conditionObj[key] = value === 'true';
  });

  return conditionObj;
}

function evaluateConditionWithFunction(condition, context, target) {
  const method = new Function('model', `return { ${condition} };`);
  return method.call(target, context);
}

function updateTarget(source, target) {
  for (const [key, value] of Object.entries(source)) {
    if (target[key] !== value) {
      Vue.set(target, key, value);
    }
  }
}
